module.exports = __webpack_public_path__ + "static/media/calificadora.89f07828.svg";